import { Record, List } from 'immutable';
import _ from 'lodash';

const SeasonFilters = new Record({
    flexi: true,
    weekly: true,
    fourWeekly: true,
    monthly: true,
    quarterly: true,
    sixMonthly: true,
    annual: true,
    custom: true,
    standard: true,
    firstClass: true,
    travelcards: true,
    routes: new List()
});

Object.assign(SeasonFilters.prototype, {

    getRoute (route) {
        return this.routes.find((o) => o.get('route').id === route.id);
    },

    updateRoute (item) {
        const routes = this.routes.map((o) => {
            return o.get('route').id === item.get('route').id ? item : o;
        });
        return this.set('routes', routes);
    },

    getCheckedRoutes () {
        return this.routes.filter((r) => r.get('checked'));
    },

    getCount () {
        const routes = this.getCheckedRoutes()
            .map((x) => x.get('checked')).toArray();

        return _.compact(_.flatten([
            this.flexi,
            this.weekly, this.monthly, this.annual, this.custom,
            this.quarterly, this.sixMonthly,
            this.standard, this.firstClass, routes
        ])).length;
    },

    durationFilter (search) {
        return (fare) => {
            const { period } = fare.outwardValidity;

            const { startDate, endDate } = search.dates;
            const customDiff = endDate.clone().add(1, 'day').calendarDiff(startDate);
            const validUntil = startDate.clone().add(period.toJS());
            const matchesDuration = (expected) => {
                const expectedEndDate = startDate.clone().add(expected);
                return validUntil.isSame(expectedEndDate);
            };

            return _.compact([
                this.flexi && fare.isFlexi(),
                this.weekly && matchesDuration({ days: 7 }),
                this.fourWeekly && matchesDuration({ days: 28 }),
                this.monthly && matchesDuration({ months: 1 }),
                this.quarterly && matchesDuration({ months: 3 }),
                this.sixMonthly && matchesDuration({ months: 6 }),
                this.annual && matchesDuration({ months: 12 }),
                this.custom && matchesDuration(customDiff)
            ]).length > 0;
        };
    },

    classFilter () {
        return (fare) => {
            return _.compact([
                this.standard && !fare.isFirstClass(),
                this.firstClass && fare.isFirstClass()
            ]).length > 0;
        };
    },

    travelcardFilter () {
        return (fare) => {
            return !this.travelcards && fare.tickets ?
                fare.tickets.some((ticket) => ticket.railcard) : true;
        };
    },

    routesFilter () {
        return (fare) => {
            const found = this.getRoute(fare.route);
            return found && found.get('checked') === true;
        };
    }

});

export default SeasonFilters;
